import React from 'react';
import { useCurrentUser } from '../../hooks/useCurrentUser';

/**
 * Visual placeholder shown in-place of a missing content block.
 *
 * Only rendered when the current user is an admin — regular visitors always
 * see the hardcoded fallback content (never a broken layout). Admins get a
 * small dashed outline with the section `key` so they know exactly what to
 * configure in `/admin/pages`.
 */
export const ContentBlockPlaceholder = ({ blockKey, children }) => {
  const { isAdmin } = useCurrentUser();

  if (!isAdmin) return children;

  return (
    <div
      data-testid={`content-block-placeholder-${blockKey}`}
      style={{ position: 'relative' }}
    >
      {children}
      <span
        style={{
          position: 'absolute',
          top: 8,
          right: 8,
          background: '#be1f1a',
          color: '#fff',
          fontSize: 11,
          fontFamily: 'monospace',
          padding: '2px 8px',
          borderRadius: 999,
          letterSpacing: '0.02em',
          zIndex: 2,
          pointerEvents: 'auto',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        edit: {blockKey}
      </span>
    </div>
  );
};

export default ContentBlockPlaceholder;
